// extracted by mini-css-extract-plugin
export default {"brandPromo":"EF-z","carousel":"FF-z"};